"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusSubscription = void 0;
const react_1 = require("react");
const useCirrus_1 = require("./useCirrus");
const useDeepCompareEffect_1 = require("./useDeepCompareEffect");
function useCirrusSubscription(request, onData) {
    const { socket } = useCirrus_1.useCirrus();
    const onDataRef = useRefCallback(onData);
    useDeepCompareEffect_1.useDeepCompareEffect(() => {
        const abortController = new AbortController();
        const responses = socket.subscribe(request);
        function watch() {
            var e_1, _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    for (var responses_1 = __asyncValues(responses), responses_1_1; responses_1_1 = yield responses_1.next(), !responses_1_1.done;) {
                        const subscribeData = responses_1_1.value;
                        if (!abortController.signal.aborted) {
                            onDataRef.current(subscribeData);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (responses_1_1 && !responses_1_1.done && (_a = responses_1.return)) yield _a.call(responses_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        }
        watch();
        return () => {
            abortController.abort();
            responses.return();
        };
    }, [request, socket.id]);
}
exports.useCirrusSubscription = useCirrusSubscription;
exports.default = useCirrusSubscription;
function useRefCallback(callback) {
    const callbackRef = react_1.useRef(callback);
    react_1.useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    return callbackRef;
}
//# sourceMappingURL=useCirrusSubscription.js.map